import { useEffect, useState } from "react";
import i18n from "constant/locales/i18n";

export function useLanguageChange() {
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(lng); // 상태 업데이트
    };
    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  return language;
}
